// Shim to replace cross-fetch with native browser fetch.
// cross-fetch's browser ponyfill uses an internal XMLHttpRequest-based fetch
// which can silently swallow errors. Native fetch works better in modern browsers.
var nativeFetch = window.fetch.bind(window);
nativeFetch.default = nativeFetch;
nativeFetch.fetch = nativeFetch;
nativeFetch.Headers = window.Headers;
nativeFetch.Request = window.Request;
nativeFetch.Response = window.Response;
module.exports = nativeFetch;
